import { ClipPersonEntity } from "./ClipPersonEntity";

export class ClientClipProjection {
  id: string;

  audioUrl: string;

  startTime: number;

  endTime: number;

  durationInSeconds: number;

  description: string;

  thumbnailImageUrl: string;

  personEntities: ClipPersonEntity[];

  constructor(
    audioUrl: string,
    startTime: number,
    endTime: number,
    durationInSeconds: number,
    description: string,
    thumbnailImageUrl: string,
    personEntities: ClipPersonEntity[]
  ) {
    this.audioUrl = audioUrl;
    this.startTime = startTime;
    this.endTime = endTime;
    this.durationInSeconds = durationInSeconds;
    this.description = description;
    this.thumbnailImageUrl = thumbnailImageUrl;

    this.personEntities = personEntities;

    this.id = `${audioUrl}-${startTime}-${endTime}-${durationInSeconds}-${description}-${thumbnailImageUrl}`;
  }
}
